import { fetchApi, responseToJson } from '@atpoint/atpjs/api'
import CancelablePromise from '@atpoint/atpjs/cancelable_promise'
import { replaceWithObject } from '@atpoint/atpjs/helpers/string'
import { apiGetWebForm, apiSubmitWebForm } from '@forms/config/requests'

import type Response from '@atpoint/atpjs/xhr_fetch/response'
import type { Map as ImmutableMap } from 'immutable'

export class ApiError {
  response: Response
  errors: CancelablePromise | null
  constructor(response: Response, errors: CancelablePromise | null = null) {
    this.response = response
    this.errors = errors
  }

  get status() {
    return this.response.status
  }

  get statusText() {
    return this.response.statusText
  }
}

type ErrorType = {
  errors?: any
  error?: any
}

export const handleStatus = (response: Response) => {
  if (response.ok) {
    return response
  } else {
    if ([400, 422].includes(response.status)) {
      const errors = responseToJson(response).then((data: ErrorType) => data.errors || data.error || data)
      return CancelablePromise.reject(new ApiError(response, errors))
    } else {
      return CancelablePromise.reject(new ApiError(response))
    }
  }
}

/**
 * id: String
 * handler: Function
 * return: Promise(json object)
 */
export const getFormDefinition = (id: string | number, handler = (x: ImmutableMap<string, any>) => x) => {
  const replace = replaceWithObject({ id: id })
  return fetchApi(replace(apiGetWebForm), 'GET').then(handleStatus).then(responseToJson).then(handler)
}

/**
 * id: String
 * handler: Function
 * return: Promise(json object)
 */

export const submitForm = (id: string | number, data: FormData) => {
  const replace = replaceWithObject({ id: id })
  return fetchApi(replace(apiSubmitWebForm), 'POST', data).then(handleStatus)
}
